
<template>
  <v-form ref="form" lazy-validation :readonly="readonly">
    <v-card color="white" class="mb-2 pa-3" elevation="0">
      <v-autocomplete v-model="model.client_portfolio_ids" chips :readonly="readonly" multiple label="Carteira de clientes" :loading="loading.client_portfolios" :items="client_portfolios" 
        prepend-icon="mdi-account-box-multiple" item-text="attributes.name" item-value="id"
        :rules="required">
        <template slot="append" v-if="!loading.client_portfolios"> 
          <v-btn icon @click="getClientPortfolios()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </template>
        <template v-slot:append-item v-if="isDirector() || isSalesExecutive()">
          <div class="d-flex justify-center ma-1">
            <v-btn small color="primary" @click="createClientPortfolio"> 
              <v-icon small left>mdi-plus</v-icon>
              Nova carteira
             </v-btn>
          </div>
        </template>
        <template v-slot:no-data>
          <div class="pa-5 subtitle-1">
            <div class="d-flex justify-center">
              <v-icon class="mr-5">mdi-alert</v-icon>
              <div class="d-flex flex-column">
                <span>Você não faz parte de  nenhuma carteira de clientes ativa.</span>
                <span class="ml-1">Peça à um Diretor para te adicionar à alguma carteira!</span>

              </div>
            </div>
          </div>
        </template>
        <template v-slot:item="{ item }">
          {{ item.attributes.name }}
        </template>
        <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
      </v-autocomplete>

    </v-card>
  </v-form>
</template>

<script>
import validations from "@/mixins/validations.js"
import Api from '@/api/index';

export default {
  name: 'ChooseClientPortfolioForm',
  mixins: [ validations ],
  props:{
    model:{
      type: Object,
      default: () => { return {} }
    },
    readonly:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      client_portfolios: [],
      loading:{
        client_portfolios: false,
      }
    }
  },
  methods: {
    createClientPortfolio(){
      const routeData = this.$router.resolve({name: 'CreateClientPortfolios'});
      window.open(routeData.href, '_blank');
    },
    getData(){
      this.getClientPortfolios()
    },
    validate(){
      return this.$refs.form.validate()
    },
    getClientPortfolios() {
      this.client_portfolios = []
      this.loading.client_portfolios = true
      Api.ClientPortfolio.index().then(r => r.data.data).then(data => {
        this.client_portfolios = [ ...data.map(el => {
          return {
            ...el,
            id: Number(el.id)
          }
        })]
      }).finally(()=>{
        this.loading.client_portfolios = false
      })
    },
  },
  mounted(){
    this.getData()
  }
}
</script>